import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const handleNavClick = (path) => {
    navigate(path);
    setMobileMenuOpen(false);
  };

  const headerClass = `header ${scrolled ? 'header-scrolled' : 'header-transparent'}`;

  return (
    <header className={headerClass}>
      <div className="nav-container">
        <div className="nav-content">
          <a href="#" className="logo-container" onClick={(e) => { e.preventDefault(); handleNavClick('/'); }}>
            <div className="logo-icon">
              <span className="logo-letter">R</span>
            </div>
            <span className="logo-text">RuaMedical</span>
          </a>
          <div className="nav-links">
            <a href="#" className="nav-link">Solutions</a>
            <a href="#" className="nav-link">Features</a>
            <a href="#" className="nav-link">Pricing</a>
            <a href="#" className="nav-link">Support</a>
            <button 
              className="btn-secondary"
              onClick={() => handleNavClick('/login')}
              style={{ whiteSpace: 'nowrap' }}
            >
              Login
            </button>
            <button 
              className="btn-primary"
              onClick={() => handleNavClick('/signup')}
              style={{ whiteSpace: 'nowrap' }}
            >
              Get Started
            </button>
          </div>
          <button className="mobile-menu-btn" onClick={toggleMobileMenu}>
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
        {mobileMenuOpen && (
          <div className="mobile-menu">
            <div className="mobile-menu-content">
              <a href="#" className="nav-link">Solutions</a>
              <a href="#" className="nav-link">Features</a>
              <a href="#" className="nav-link">Pricing</a>
              <a href="#" className="nav-link">Support</a>
              <button 
                className="btn-secondary"
                onClick={() => handleNavClick('/login')}
                style={{ width: '100%', marginTop: '0.5rem' }}
              >
                Login
              </button>
              <button 
                className="btn-primary"
                onClick={() => handleNavClick('/signup')}
                style={{ width: '100%', marginTop: '0.5rem' }}
              >
                Get Started
              </button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
